var map = {
	"./back_items/1.png": "79c0",
	"./back_items/10.png": "5ad1",
	"./back_items/2.png": "8553",
	"./back_items/3.png": "3d60",
	"./back_items/4.png": "191f",
	"./back_items/5.png": "f43e",
	"./back_items/6.png": "ef95",
	"./back_items/7.png": "4722",
	"./back_items/8.png": "b5dd",
	"./back_items/9.png": "2dee",
	"./carpets/1.png": "6e08",
	"./carpets/2.png": "5b42",
	"./carpets/3.png": "f5ec",
	"./carpets/4.png": "8dd5",
	"./carpets/5.png": "aa9a",
	"./carpets/6.png": "a8e0",
	"./carpets/7.png": "d42f",
	"./carpets/8.png": "2d2d",
	"./chairs/1.png": "0cb4",
	"./chairs/10.png": "74da",
	"./chairs/2.png": "1c12",
	"./chairs/3.png": "12a2",
	"./chairs/4.png": "1323",
	"./chairs/5.png": "ea73",
	"./chairs/6.png": "723f",
	"./chairs/7.png": "1bb3",
	"./chairs/8.png": "8094",
	"./chairs/9.png": "a9cb",
	"./deco/1.png": "762d",
	"./deco/2.png": "23e3",
	"./deco/3.png": "5eeb",
	"./deco/4.png": "151d",
	"./deco/5.png": "5bb8",
	"./lamps/1.png": "aeb2",
	"./lamps/2.png": "def4",
	"./lamps/3.png": "a9ba",
	"./lamps/4.png": "7752",
	"./lamps/5.png": "7bac",
	"./lamps/6.png": "209c",
	"./lamps/7.png": "99ec",
	"./wall_items/1.png": "d1cb",
	"./wall_items/2.png": "9c18",
	"./wall_items/3.png": "b238",
	"./wall_items/4.png": "c129",
	"./wall_items/5.png": "fc60",
	"./wall_items/6.png": "7043",
	"./wall_items/7.png": "4c46",
	"./wall_items/8.png": "7975",
	"./wall_items/9.png": "9f2c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "41b5";